<template>
  <CContainer>
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CAlert
          v-if="reqResponse.message"
          class="mt-4"
          :color="reqResponse.type"
          :show="!!reqResponse.message"
        >
          {{ reqResponse.message }}
        </CAlert>
        <div class="mb-2">
          <div class="form-group">
            <textarea
              v-model="form.message"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.message.$error || reqResponse.errors['message']
              }"
              placeholder="There is currently a student already on a pass that you can't be in the hall with. Please try again later."
              rows="8"
            />
            <div
              v-if="v$.form.$error && v$.form.message.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div v-if="reqResponse.errors['message']" class="invalid-feedback">
              {{ reqResponse.errors["message"][0] }}
            </div>
          </div>

          <div class="form-group form-actions mt-4 text-center">
            <div class="d-flex align-items-center justify-content-center">
              <div @click="submit()">
                <CLoadingButton
                  :spinner="isLoading"
                  :disabled="isLoading"
                  :loading="isLoading"
                  class="me-2 px-5 py-3 btn bg-gradient-blue text-white"
                >
                  Submit
                </CLoadingButton>
              </div>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
import { mapGetters } from "vuex"

export default {
  name: "CreateABPolarityForm",
  setup() {
    return { v$: useVuelidate() }
  },
  components: {},
  data() {
    return {
      isLoading: false,
      form: {
        message: ""
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  validations: {
    form: {
      message: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      polarityMessage: "polarities/polarityMessage"
    }),
    isValid() {
      return !this.v$.form.$invalid
    }
  },
  mounted() {
    if (!this.polarityMessage) {
      this.$store.dispatch("polarities/getPolarityMessage").then((response) => {
        const data = response.data.data
        if (data && Object.prototype.hasOwnProperty.call(data, "message")) {
          this.$store.commit("polarities/SET_POLARITY_MESSAGE", data.message)
          this.form.message = data.message
            ? data.message
            : data.initial_default_value
        }
      })
    }
    this.form.message = this.polarityMessage
  },
  methods: {
    submit() {
      this.resetResponseMessages()
      if (this.isValid) {
        const polarity = {
          message: this.form.message
        }
        this.isLoading = true
        this.$store
          .dispatch("polarities/createPolarityMessage", polarity)
          .then((response) => {
            const data = response.data.data
            if (data && Object.prototype.hasOwnProperty.call(data, "message")) {
              this.$store.commit(
                "polarities/SET_POLARITY_MESSAGE",
                data.message
              )
            }
            this.setSuccessResponse("Successfully created.")
            this.isLoading = false
            setTimeout(() => {
              this.resetResponseMessages()
            }, 1000)
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
            this.isLoading = false
          })
      } else {
        this.v$.$touch()
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    }
  }
}
</script>
